/* Bausteine für die mitgelieferten Board-Vorlagen (templateCatalog.ts, templateCatalogFinanz.ts) */
import type { BoardTemplateData, TemplateExampleCard } from './templates.js';
import type { FieldOption, LabelColor } from './types.js';
import type { ViewConfig } from './filter.js';
import type { Widget } from './dashboard.js';

type Card = TemplateExampleCard;
/** Beispielkarte: Spalte, Titel, Labels (Index), weitere Angaben */
export const c = (column: number, title: string, labels: number[] = [], more: Partial<Omit<Card, 'column' | 'title'>> = {}): Card => ({
  column,
  title,
  labelIds: labels.map((i) => `label:${i}`),
  ...more,
});
/** „Erledigt“ ist in allen mitgelieferten Vorlagen grün (0.49) */
export const cols = (...titles: (string | BoardTemplateData['columns'][number])[]) =>
  titles.map((t) => (typeof t === 'string' ? { title: t, ...(t === 'Erledigt' ? { color: 'green' as const } : {}) } : t));
/** Auswahloptionen: [ID, Beschriftung, Farbe] */
export const opts = (...o: [string, string, LabelColor][]): FieldOption[] => o.map(([id, label, color]) => ({ id, label, color }));
/** Auswahlfeld hat diesen Wert bekommen */
export const fieldBecomes = (field: number, optionId: string) => ({ type: 'fieldChanged' as const, fieldId: `field:${field}`, to: { op: 'anyOf' as const, optionIds: [optionId] } });
/** 0.70: geteilte Ansicht (Labels als Index) */
export const view = (name: string, c: Partial<Omit<ViewConfig, 'filter'>> & { filter?: ViewConfig['filter'] } = {}) => ({
  name,
  config: { filter: {}, sort: 'manual' as const, density: 'standard' as const, ...c } as ViewConfig,
});
export const labelsOf = (...i: number[]) => i.map((x) => `label:${x}`);
/** 0.70: Bausteine der Boardübersicht (IDs werden beim Anlegen neu vergeben) */
let widgetSeq = 0;
export const wg = (type: Widget['type'], size: 4 | 6 | 12, config: Record<string, unknown> = {}, title: string | null = null, filter: Record<string, unknown> = {}): Widget =>
  ({ id: `tplw${String(++widgetSeq).padStart(4, '0')}`, type, size, title, filter, config }) as Widget;
export const ROWS = { rows: 10 };
export const done = (col: number) => ({ name: 'Letzte Spalte hakt ab', trigger: { type: 'moved' as const, columnId: `col:${col}` }, actions: [{ type: 'complete' as const }] });
export const meOn = (col: number, name = 'Arbeitsbeginn: mir zuweisen') => ({
  name,
  trigger: { type: 'moved' as const, columnId: `col:${col}` },
  actions: [{ type: 'assign' as const, userId: 'actor' }],
});

